import script from "./EmailInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./EmailInfoModal.vue?vue&type=style&index=0&id=98743cf2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98743cf2"]])

export default __exports__